// 3p
import {createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

// Fp
import rootReducer from './reducers';
import rootSaga from './sagas';

export default function configureStore() {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(
    rootReducer,
    compose(
      applyMiddleware(sagaMiddleware),
      window.devToolsExtension ? window.devToolsExtension() : f => f
    )
  );

  sagaMiddleware.run(rootSaga);

  return store;
}



/** WEBPACK FOOTER **
 ** ./src/store/configure-store.js
 **/